import { ICaseStudyData } from "@/interfaces";
import { TreatmentCaseStudy } from "./TreatmentCaseStudy";
import { TreatmentSummary } from "./TreatmentSummary";
import { TreatmentAccodian } from "./TreatmentAccodian";
import { TreatmentFeedBack } from "./TreatmentFeedBack";

type props = {
    caseStudyData: ICaseStudyData
}
export function CaseStudy({ caseStudyData }: props) {
    return <>
         <TreatmentCaseStudy caseStudyData={caseStudyData.caseStudyDetails}/>
         <TreatmentSummary caseStudyData={caseStudyData.caseStudyDetails}/>
         <TreatmentAccodian caseStudyData={caseStudyData.caseStudyDetails}/>
         <TreatmentFeedBack caseStudyData={caseStudyData.caseStudyDetails}/>
    </>
}